import type { SxProps, Theme } from "@mui/material/styles";

export const card: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  borderRadius: 2.75,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[3],
  p: { xs: 2.5, sm: 2.75 },
  display: "flex",
  flexDirection: "column",
  gap: 2.5,
});

export const header: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
  flexWrap: "wrap",
};

export const titleRow: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const title: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: "1rem",
};

export const trendChip: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.625,
  color: "success.main",
  fontWeight: 600,
};

export const chartWrap: SxProps<Theme> = {
  display: "flex",
  alignItems: "flex-end",
  gap: { xs: 1, sm: 1.75 },
  height: 180,
};

export const barColumn: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1.25,
  height: "100%",
  justifyContent: "flex-end",
};

export const bar =
  (height: string, fill: string): SxProps<Theme> =>
  ({
    width: "100%",
    maxWidth: 40,
    height,
    borderRadius: "8px 8px 0 0",
    bgcolor: fill,
    transition: "height 0.2s ease",
  });

export const emptyState: SxProps<Theme> = (theme) => ({
  py: theme.spacing(6),
  display: "flex",
  justifyContent: "center",
});

export const emptyBox =
  (theme: Theme): SxProps<Theme> =>
  ({
    height: 210,
    border: `2px dashed ${theme.palette.divider}`,
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 1.5,
    textAlign: "center",
    px: 2,
  });

export const emptyDescription: SxProps<Theme> = {
  maxWidth: 260,
  lineHeight: 1.7,
};
